/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Item } from '../../models/item';

export interface AddParent$Params {
  itemId: string;
  parentId: string;
}

export function addParent(http: HttpClient, rootUrl: string, params: AddParent$Params, context?: HttpContext): Observable<StrictHttpResponse<Item>> {
  const rb = new RequestBuilder(rootUrl, addParent.PATH, 'post');
  if (params) {
    rb.query('itemId', params.itemId, {});
    rb.query('parentId', params.parentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Item>;
    })
  );
}

addParent.PATH = '/admin/items/parent/add';
